<script setup>
import CardForm from "@/components/CardForm";
import FormInputEmail from "@/components/FormInputEmail";
import FormInputPassword from "@/components/FormInputPassword";
import {ref} from "vue";
import store from "@/store";
import router from "@/router";
import i18n from "@/i18n";
import {useToast} from "vue-toastification";

const {t} = i18n.global;

const email = ref('');
const password = ref('');

const login = async () => {
  await store.dispatch('login', {email: email.value, password: password.value});
  if (store.getters.self.role === 'manager') {
    useToast().error('Managers don\'t use this admin portal, but the app. Please ask your manager to help you set it up on your phone.');
  } else {
    await router.push('/');
  }
}
</script>

<template>
  <img class="mb-3 mt-3" width="150" src="@/assets/icons/rubik-logo.svg"/>
  <p class="mb-5">{{ t('anonymous.login.description') }}</p>

  <card-form
      :action="t('anonymous.login.form.action')"
      @did-submit="login"
  >
    <form-input-email
        v-model.trim="email"
        label-group="anonymous.login.form.email"
    />
    <form-input-password
        v-model.trim="password"
        label-group="anonymous.login.form.password"
        autocomplete="new-password"
    />
  </card-form>

  <div class="mt-5 mb-5">
    <a href="/onboarding">{{ t('anonymous.footer.nav.signUp') }}</a>
    &bull;
    <a href="/account/password">{{ t('anonymous.footer.nav.recover') }}</a>
  </div>
</template>